<h3 *ngIf="data == null" mat-dialog-title>Cadastrar Tipo de Custo</h3>
<h3 *ngIf="data != null" mat-dialog-title>Alterar Tipo de Custo</h3>
<div mat-dialog-content>
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field 
                style="width: 100%" 
                appearance="outline" 
                fxFlex="100" 
                floatLabel="always"
            >
                <mat-label>Nome</mat-label>
                <input 
                    matInput 
                    placeholder="Nome" 
                    [formControl]="descricao" 
                    required
                    maxlength="255">
                <mat-error *ngIf="descricao.invalid">{{getErrorNameMessage()}}</mat-error>
            </mat-form-field>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button [disabled]="isInvalidForm()" (click)="salvar()" tabindex="-1">Salvar</button>
</div>